import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";

function initSourcePhonesIndex() {
	// Init grid
	const grid = createGrid('.phones-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Name',
					sortable: true,
				},
				{
					field: "number",
					headerName: 'Number',
					sortable: true,
				},
				{
					field: "forward_sms_email",
					headerName: 'SMS Email Target',
					sortable: true,
				},
				{
					field: "forward_call_number",
					headerName: 'Call Number Target',
					sortable: true,
				},
				{
					field: "created_at",
					headerName: 'Created',
					width: 200,
					sortable: true,
				},
				{
					field: "id",
					headerName: '',
					maxWidth: 240,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
                            <div class="buttons">
                                <a class="btn btn-primary btn-sm" href="${params.data.edit_url}">
                                    <i class="fa-solid fa-user-pen"></i>
                                    Edit
								</a>
                                <button type="button" class="btn btn-danger btn-sm remove-phone-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Remove
                                </button>
                            </div>`
						)

						const deleteButton = buttons.querySelector('.remove-phone-button');

						deleteButton.onclick =
							() => removePhone(params.data);

						// Remove delete button from admin
						if (params.data.id === 1) {
							deleteButton.remove();
						}

						return buttons;
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Phones',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.edit_url;
			}),
		},
		window['routes/admin.source-phones.grid'],
	);

	/** Methods */

	function removePhone(user) {
		swalConfirm({
			title: 'Are you sure you want to delete this phone?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(user.remove_url)
					.then(response => {
						handleAjaxSuccess(response, () => {
							grid._refresh();
						})
					})
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})

	}
}

export {
	initSourcePhonesIndex
}
